// Labels and guidance for saved generations created before script creation was retired.
export default [
	{
		key: 'Video to storyboard',
		value: 'VIDEOTOSTORYBOARD',
		tips: [
			'Use this storyboard to brief editors or guide AI video tools.',
			'Copy it as JSON or Markdown for a shot list.',
		],
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 3h14v18H5zM8 8h8M8 12h8M8 16h5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
	},
	{
		key: 'Ad concept',
		value: 'CONCEPT',
		tips: ['Use these hooks and angles to plan your next ad.'],
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 18h3M4 12h5M4 6h16M17 10l1.5 3.5L22 15l-3.5 1.5L17 20l-1.5-3.5L12 15l3.5-1.5L17 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
	},
	{
		key: 'Video script',
		value: 'VIDEO',
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="m10 8 6 4-6 4V8z" fill="currentColor"/></svg>',
	},
	{
		key: 'Ad copy',
		value: 'COPY',
		tips: ['Use this copy in your ads, captions, or landing pages.'],
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 20h4L20 8l-4-4L4 16v4zM14 6l4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
	},
];
